
class ArticleList extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, container, listRow, gridView, searchInputId = 'searchTable', config = {excludePosts : false, swapButton: false, cardFooter : true}, renderList = true, forceRefresh = false) {
    super(app, container, listRow, searchInputId);
    this.config = config;
    this.forceRefresh = forceRefresh;
    if(renderList){
      this.gridView = gridView;
      this.paginator = new Paginator(30);
      this.container.empty();
      this.renderList = this.renderList.bind(this);
      this.listRow = `feed__${this.gridView}-article`;
      const page = _.template(app.templates[`feed__articles-${this.gridView}`]);
      let $row = $(page({}));
      $row.appendTo(this.container);
      this.container = $('[data-articles-container]', this.container);
      Responsive.getCalendarColumn( this.container,  this.container);
      this.lazyloader = new LazyLoader(app, this.container, this.renderList);
      this.renderList();
    }
  }

  prepareRow(row, userTimeZone) {
    const self = this;
    const defaults = {'statusClass': 'not-in-calendar', segments: 'custom', showMaximize: true, plan: 'free', swapButton : this.config.swapButton, cardFooter : this.config.cardFooter};

    if (!this.app.isEmpty(row.status)) {
      defaults.statusClass = row.status;
    }

    row = {...defaults, ...row};
    row.articleDate = row.date.postDate;

    const postImage = _.template(this.app.templates['calender__partials-post-image']);
    row.postImage = postImage(row);

    const postNetworks = _.template(this.app.templates['calender__partials-post-networks']);
    row.postNetworks = postNetworks(row);

    //row.scheduleDate = row.d.postDate;
    if (row.segments === 'article') {

    }

    let $card;
    if (!this.app.isEmpty(row.post_id)) {
      row.postDate = row.d.postDate;
      row.removeFromCalendar = true;
      const postInfo = _.template(this.app.templates['calender__partials-post-info']);
      row.postInfo = postInfo(row);

      const postFooter = _.template(this.app.templates['calender__partials-post-footer']);
      row.postFooter = postFooter(row);

      const page = _.template(this.app.templates[`feed__${this.gridView}-article`]);
      $card = $(page(row));
    } else {
      const postInfo = _.template(this.app.templates['feed__article-body']);
      row.postInfo = postInfo(row);

      const postFooter = _.template(this.app.templates['feed__article-footer']);
      row.postFooter = postFooter(row);

      const page = _.template(this.app.templates[`feed__${this.gridView}-article`]);
      $card = $(page(row));
    }

    let $images = $('.svg-object, .post-image', $card);

    $images.each(function (index, image) {
      if ($(image).attr('data-src') !== '') {
        self.app.observerManager.observeIntersection(image);
      }
    });
    return $card;
  }

  renderView(data) {
    let self = this;
    _.each(data, function (row) {
      if(!self.app.isEmpty(row)) {
        window.articles[row.id] = row;
        let $row = self.prepareRow(row, self.userTimeZone);
        $row.appendTo(self.container);
      }
    });
  }

  loaderData = {
    post_id : null,
    postNetworks: '',
    id: null,
    postImage: '',
    link: '',
    swapButton :'',
    postInfo: '',
    postFooter: '',
    domain : '',
    cardFooter : true,
    actionStatus : '',
    title: this.staticPH,
    articleDate: this.staticPH,
    image: '',
    segments: 'article',
    showMaximize: '',
    plan: 'free'
  }

  processedLoaderData(overrideData = {}) {
    let data = this.loaderData;
    data.postImage = _.template(this.app.templates['calender__partials-post-image']);
    data.postImage = data.postImage(data);

    const postInfo = _.template(this.app.templates['feed__article-body']);
    data.postInfo = postInfo(data);

    const postFooter = _.template(this.app.templates['feed__article-footer']);
    data.postFooter = postFooter(data);

    data = {...data, ...overrideData};
    return data;
  }

  async storeArticles (response) {
    const self = this;
    if(this.app.isEmpty(response)) {
      response = await this.app.apis['article'].fetch(this.app.calendarId);
    }
    const defaults = {
      segments: 'article',
      showMaximize: true,
      headerText: '',
      saveButtonText: '',
      plan: 'free',
      statusBadge: 'primary',
      statusClass: '',
      networks: [],
      postDate: '',
    };

    // Only show data with display 1 or status unscheduled

    response.data = response.data.filter(function (row) { return row.display === "1" || ['unscheduled', 'posted'].includes(row.status)});

    response.data = response.data.map(post => {
      post = {...post, ...defaults};
      if (!this.app.isEmpty(post.d)) {
        post.actionStatus = PostFormatter.actionStatus(post);
        post.d = PostFormatter.formatTime(post.d, this.userTimeZone);
        const postTime = PostFormatter.formatPostTime(post, this.userTimeZone);
        post = {...postTime, ...post}
      } else {
        post.postEditorTime = null;
      }
      post.statusBadge = PostFormatter.getStatusBadge(this.app, post);
      post.date = PostFormatter.formatTime(post.date.date, this.userTimeZone)
      post.domain = Utils.getDomain(post.link);
      return post;
    });

    window.articlePosts = this.app.clone(response.data);
    window.articlePosts = window.articlePosts.filter(post => {
      post.text = post.title
      return post;
    });
    window.articlePosts = _.indexBy(window.articlePosts, 'id');
    window.articles = this.app.clone(response.data);

    if(this.config.excludePosts === true) {
      window.articles = window.articles.filter(post => {
        return self.app.isEmpty(post.d);
      });
    }

    let calendarPosts = await this.app.apis['calendar'].posts(this.app.calendarId);
    PostsList.storePosts(calendarPosts);
  }

  async renderList() {
    const self = this;
    const $listContainer = this.container
    let articles = [];
    this.isRendering = true;

    try {
      this.showLoader(this.processedLoaderData());

      if (this.app.isEmpty(window.articles) || this.forceRefresh === true) {
        const response = await this.app.apis['article'].fetch(this.app.calendarId);
        await this.storeArticles(response);
      }

      this.removeLoader();

      if (!this.app.isEmpty(window.articles)) {
        if (this.paginator.currentPage === null) {
          this.paginator.setData(window.articles);
          this.paginator.setCurrentPage(1);
          articles = this.paginator.getCurrentPage();

        } else {
          articles = this.paginator.getNextPage();
        }

        this.renderView(articles);

        this.app.initTooltip();

        this.isRendering = false;
        return this.paginator.hasMoreData();

      } else {
        console.log("here");
        const noRecordsOptions = {
          title: 'No Articles Found',
          class: 'available-card-viewport no-articles',
          description: 'You need to add feeds and set them active',
          addButton: {
            text: 'Take me to feeds',
            onClick: () => {
              this.app.redirect(`/calendar/${this.app.calendarId}/feeds`);
            }
          },
          help: {
            text: 'Need Help ?',
            onClick: () => {
              console.log('Help clicked');
              // Code to open help documentation or contact support
            }
          }
        };

        const placeholder = new NoRecordsPlaceholder(this.app, this.container.parent(), noRecordsOptions);
        placeholder.render();
      }

    } catch (error) {
      console.error("Error occurred during operation:", error);
    }
  }
}